import { render, staticRenderFns } from "./providerForm.vue?vue&type=template&id=dadd2f0e&scoped=true&"
import script from "./providerForm.vue?vue&type=script&lang=babel&"
export * from "./providerForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd2f0e",
  null
  
)

export default component.exports